export class SrecOffsetMonthOption {
  public offsetMonth: number;
  public selected: boolean;

  constructor(offsetMonth: number, selected: boolean) {
    this.offsetMonth = offsetMonth;
    this.selected = selected;
  }
}